import React, {useEffect} from 'react';
import {can, translate} from "utils/helpers";
import {useScheduleContext} from "context/ScheduleContext";
import {Badge, Dropdown} from "antd";
import {IoEllipsisVerticalSharp} from "react-icons/all";
import {Table} from "components/ui";

function ScheduleTable(props) {

    const {
        translateKey,
        permission,
        handleModal,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleAction,
        handleDelete
    } = useScheduleContext();

    const columns = [
        {
            title: translate(translateKey + '.Label.Name'),
            dataIndex: 'name',
            width: 180,
        },
        {
            title: translate(translateKey + '.Label.Room'),
            dataIndex: 'room',
            render: value => value?.name || '',
            width: 180,
        },
        {
            title: translate(translateKey + '.Label.Date'),
            dataIndex: 'date',
            width: 100,
            align: 'center'
        },
        {
            title: translate(translateKey + '.Label.StartTime'),
            dataIndex: 'start_time',
            width: 100,
            align: 'center'
        },
        {
            title: translate(translateKey + '.Label.EndTime'),
            dataIndex: 'end_time',
            width: 100,
            align: 'center'
        },
        {
            title: translate(translateKey + '.Label.Note'),
            dataIndex: 'note',
        },
    ];

    const actionRender = (row) => {
        const menus = (
            <div className="dropdown dropdown--sm">
                <div className="dropdown-body">
                    <div className="dropdown-items">
                        {can(permission + '.update') && (
                            <button
                                onClick={() => handleModal('form', true, row)}
                                className="dropdown-item h-8"
                            >
                                {translate('button.Edit')}
                            </button>
                        )}
                        {can(permission + '.action') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleAction(row.id)}
                            >
                                {row.is_active ? translate('button.DeActivate') : translate('button.Activate')}
                            </button>
                        )}
                        {can(permission + '.delete') && (
                            <button
                                className="dropdown-item h-8"
                                onClick={() => handleDelete(row.id)}
                            >
                                {translate('button.Delete')}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
        return <Dropdown overlay={menus} placement={'bottomRight'}>
            <button className="btn btn--action bg-gray-100 text-gray-900 dark:bg-transparent dark:text-gray-300">
                <span>
                    <IoEllipsisVerticalSharp/>
                </span>
            </button>
        </Dropdown>
    }

    useEffect(() => {
        fetchDataSource()
    }, [query])

    return (
        <Table
            tableQuery={query}
            setTableQuery={handleQuery}
            dataSource={dataSource.data}
            total={dataSource.total}
            columns={columns}
            loading={tableLoading}
            sortingStart={1}
            actionWidth={40}
            actionButton={row => actionRender(row)}
        />
    );
}

export default ScheduleTable;
